import type { B2BInvoiceStatus } from "../types";

const STATUS_LABELS: Record<B2BInvoiceStatus, string> = {
  draft: "Szkic",
  submitted: "Złożona",
  approved: "Zatwierdzona",
  booked: "Zaksięgowana",
  transferred_for_payment: "Przekazana do opłacenia",
  paid: "Opłacona",
  rejected: "Odrzucona",
};

const STATUS_COLORS: Record<B2BInvoiceStatus, string> = {
  draft: "bg-slate-100 text-slate-700 border-slate-300",
  submitted: "bg-amber-100 text-amber-800 border-amber-300",
  approved: "bg-sky-100 text-sky-800 border-sky-300",
  booked: "bg-indigo-100 text-indigo-800 border-indigo-300",
  transferred_for_payment: "bg-violet-100 text-violet-800 border-violet-300",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-300",
  rejected: "bg-rose-100 text-rose-800 border-rose-300",
};

export function B2BInvoiceStatusBadge({ status }: { status: B2BInvoiceStatus }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium ${STATUS_COLORS[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
